import React, { useEffect, useState } from "react";
import { Box, Grid, TextField } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import useFetchIssueClassificationById from "../../hooks/useFetchClassificationById";
import { useBreadCrumbContext } from "../../contexts/BreadCrumbContext";
import { IconBtnEditBase } from "../../common/utils/icons";
import Loader from "../../components/Molecules/Loader/Loader";
import { useAuth } from "../../contexts/AuthContext";
import { useAppTranslation } from "../../hooks/useAppTranslation";

const ViewClassification: React.FC = () => {
  const { setCurrentBreadcrumbPage } = useBreadCrumbContext();
  const navigate = useNavigate();
  const { hasPermission } = useAuth();
  const { t } = useAppTranslation();
  const { id: classificationId } = useParams();

  const canEditClassification = hasPermission("classification", "edit");

  const [formData, setFormData] = useState<any>({
    issue_classification_name: "",
    is_active: true,
  });
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const [classificationData] = useFetchIssueClassificationById({
    setIsLoading,
    currentClassificationId: classificationId,
  });

  useEffect(() => {
    if (classificationData) {
      setFormData({
        issue_classification_name:
          classificationData?.issue_classification_name,
        is_active: classificationData?.is_active,
      });
      setCurrentBreadcrumbPage({
        name: classificationData?.issue_classification_name,
        id: classificationData?.id,
      });
    }
    return () => {
      setCurrentBreadcrumbPage({ name: "", id: null });
    };
  }, [classificationData, setCurrentBreadcrumbPage]);

  return (
    <>
      {isLoading && <Loader isLoading={isLoading} />}
      <Box>
        <Box className="text-box-card-white">
          <Box className="text-box-header">
            <h3>{t("classification.view.header")}</h3>
            {canEditClassification && (
              <button
                className="btn-nostyle icon-btn-edit"
                onClick={() =>
                  navigate(`/classification/edit/${classificationId}`)
                }
              >
                <IconBtnEditBase
                  width={32}
                  height={32}
                  ariaLabel={t("classification.view.ariaEdit")}
                />
              </button>
            )}
          </Box>
          <Grid container rowSpacing={1.5} columnSpacing={2.5}>
            <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
              <label className="label-text">
                {t("classification.view.label.classificationName")}
              </label>
              <TextField
                type="text"
                name="issue_classification_name"
                value={formData?.issue_classification_name || ""}
                className="form-control read-only"
                disabled
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
              <label className="label-text">
                {t("classification.view.label.status")}
              </label>
              <TextField
                type="text"
                name="is_active"
                value={
                  formData?.is_active
                    ? t("common.status.active")
                    : t("common.status.inactive")
                }
                className="form-control read-only"
                disabled
              />
            </Grid>
          </Grid>
        </Box>
      </Box>
    </>
  );
};

export default ViewClassification;
